$(document).ready(function() {
	var $tabsection = $('.sectionTabbedContent');
	var $tablink = $('.tabbed-content-links .link', $tabsection);

	$tablink.on('click', function() {
		$tablink.removeClass('active');
		$(this).addClass('active');
		
		var linkIndex = $(this).index();
		$('.tabbed-content-tab', $tabsection).removeClass('active');
		
		var $tab = $('.tabbed-content-tab:eq(' + linkIndex + ')', $tabsection);
		$tab.addClass('active');
	});
	
});